import { Component, OnInit } from '@angular/core';
import { HrccService } from 'app/services/hrcc.service';
import { CommonService } from 'app/services/common.service';
import { DomSanitizer } from '@angular/platform-browser';
import { PaperflowService } from 'app/services/paperflow.service';
import { Router, ActivatedRoute } from '@angular/router';
import { SubmitLeave } from '../bean/submit-leave';
import { SickLeaveListService } from 'app/services/sick-leave-list.service';
import {trigger, state, style, animate, transition} from '@angular/animations';

@Component({
  selector: 'app-hrcc-certificate-view',
  templateUrl: './hrcc-certificate-view.component.html',
  styleUrls: ['./hrcc-certificate-view.component.css'],
  animations: [
    // Each unique animation requires its own trigger. The first argument of the trigger function is the name
    trigger('rotatedState', [
      state('default', style({ transform: 'rotate(0)' })),
            state('rotated90', style({ transform: 'rotate(90deg)' })),
            state('rotated180', style({ transform: 'rotate(180deg)' })),
            state('rotated270', style({ transform: 'rotate(270deg)' })),
            state('rotated360', style({ transform: 'rotate(360deg)' })),
            transition('default => rotated90', animate('200ms ease-out')),
            transition('rotated90 => rotated180', animate('200ms ease-out')),
            transition('rotated180 => rotated270', animate('200ms ease-out')),
            transition('rotated270 => rotated360', animate('200ms ease-out')),
            
  ])
]
})
export class HrccCertificateViewComponent implements OnInit {

  public certificateEnableFlag;
  public certificateViewErrorFlag;
  public certificateViewError;
  public certificateViewData;
  public correctionFormEnableFlag;
  public certificateError;
  public certificateErrorFlag;
  public successFlag;
  public successMsg;
  public empDetailsFlag;
  public employeeObject;
  public absenceDetailsFlag;
  public absenceObject;
  public certificateData;
  public suggestionList;
  public prefdLang;
  public empID;
  public employeeId;
  public certObject;
  public suggetionListFlag;
  public certObject_fake = {
    "ID": 0,
    "absenceID": "",
    "revisionKey": 0,
    "employeeID": "",
    "ocrStartDate": "",
    "ocrEndDate": "",
    "typeOfMatch": "",
    "ocrCertDate": "",
    "certificateID": "",
    "status": ""
  };
  public absenceIdsList;
  public absenceObjectList;
  public employeeObject_fake = {
    "firstName": "N/A",
    "lastName": "N/A",
    "username": "N/A",
    "emailID": "N/A",
    "empID": "N/A",
    "prefdLang": "fr",
    "empType": "N/A",
    "contactNumber": "N/A",
    "contactNumPersonal": "N/A",
    "addressInfo": {
      "addressType": "N/A",
      "address": {
        "streetName": "N/A",
        "streetNumber": "N/A",
        "boxNo": "N/A",
        "city": "N/A",
        "postalCode": "N/A",
        "country": "N/A"
      }
    },
    "managerInfo": {
      "firstName": "N/A",
      "lastName": "N/A",
      "contactNumber": "N/A",
      "emailID": "N/A",
      "empID": "N/A"
    }
  };

  public rotateDegree = 0;
  public rotateDegreeString = '0';
  
  constructor(public hrccService: HrccService,
    public commonService: CommonService,
    public paperflowService: PaperflowService,
    private _sanitizer: DomSanitizer,
    public router: Router,
    public activatedRoute: ActivatedRoute,
    public sickLeaveListService: SickLeaveListService) { }

  ngOnInit() {
    this.certificateEnableFlag = false;
    this.absenceIdsList = [];
    this.absenceObjectList = [];
    this.prefdLang = "";
    this.empID = "";
    this.suggestionList = [];
    this.empDetailsFlag = false;
    this.certificateErrorFlag = false;
    this.absenceDetailsFlag = false;
    if(this.activatedRoute.snapshot.paramMap.get('certificateID') != null){}
    const certificateID = this.activatedRoute.snapshot.paramMap.get('certificateID');
    const employeeID = this.activatedRoute.snapshot.paramMap.get('employeeID');
    this.employeeId = this.activatedRoute.snapshot.paramMap.get('employeeID');
    this.getEmployeeDetails(employeeID);
    this.getAbsenceById(certificateID);
    this.getCertificate(certificateID, 'main');
    this.getLeaveHistory(employeeID);
    this.suggetionListFlag = false;
  }

  closeCorrectionForm(closeCorrectionView: any) {
    this.successFlag = false;
    this.correctionFormEnableFlag = !closeCorrectionView.closeFlag;
    if (closeCorrectionView.closeMsg === 'submit') {
      this.successFlag = true;
      this.successMsg = 'Correction successful!';
    }
  }

  openCorrectionForm() {
    this.correctionFormEnableFlag = true;
  }

  getAbsenceById(certificateId) {
    this.paperflowService.getAbsenceByCertificateId(certificateId).subscribe(
      (res: any) => {
        this.absenceDetailsFlag = res.status === 'success' ? true : false;
        if (this.absenceDetailsFlag === false) {
          this.certObject = this.certObject_fake;
          this.absenceDetailsFlag = true;
          this.absenceObjectList.push(this.certObject_fake);
        } else {
          this.absenceIdsList = [];
          this.certObject = res.response.absences[0];
          this.absenceObjectList = res.response.absences;
          res.response.absences.forEach(element => {
            this.absenceIdsList.push(element.absenceID);
          });
        }
      },
      (err) => {
        if (err.status === 401) {
          alert('You are either unauthorized or your seesion is expired!');
          this.sickLeaveListService.redirectToSAB();
        }
        this.absenceIdsList = [];
        this.absenceDetailsFlag = true;
        this.certObject = this.certObject_fake;
        this.absenceObjectList.push(this.certObject_fake);
        alert('Not able to get the certificate information!');
      });
  }

  getEmployeeDetails(employeeId) {
    this.hrccService.getEmployeeByEmployeeId(employeeId)
      .subscribe(
        (res: any) => {
          this.empDetailsFlag = res.status === 'success' ? true : false;
          if (this.empDetailsFlag === false) {
            this.employeeObject = this.employeeObject_fake;
            this.empDetailsFlag = true;
          }
          else {
            this.employeeObject = res.response.emp;
          }
        },
        (err) => {
          if (err.status === 401) {
            alert('You are either unauthorized or your seesion is expired!');
            this.sickLeaveListService.redirectToSAB();
          }
          this.empDetailsFlag = true;
          this.employeeObject = this.employeeObject_fake;
          alert('Not able to get the employee information!');
        });
  }

  getCertificate(certificateId, type) {
    if (type === 'main') {
      this.certificateErrorFlag = false;
      this.certificateError = '';
    }
    if (type === 'other') {
      this.certificateViewErrorFlag = false;
      this.certificateViewError = '';
    }
    this.commonService.getCertificate(certificateId)
      .subscribe(
        (res) => {
          if (res.status === 'success') {
            if (type === 'main') {
              this.certificateData = this._sanitizer.bypassSecurityTrustResourceUrl('data:image/*;base64,' + res.response.base64image);
            }
            if (type === 'other') {
              this.certificateViewErrorFlag = true;
              this.certificateViewData = this._sanitizer.bypassSecurityTrustResourceUrl('data:image/*;base64,' + res.response.base64image);
            }
          }
          else {
            if (res.status === 'fail') {
              if (type === 'main') {
                this.certificateErrorFlag = true;
                this.certificateError = 'Unable to get the certificate!';
              }
              if (type === 'other') {
                this.certificateViewErrorFlag = true;
                this.certificateViewError = 'Unable to get the certificate!';
              }
            }
          }
        }, (err) => {
          if (err.status === 401) {
            alert('You are either unauthorized or your seesion is expired!');
            this.sickLeaveListService.redirectToSAB();
          }
          if (type === 'main') {
            this.certificateErrorFlag = true;
            this.certificateError = 'Unable to get the certificate!';
          }
          if (type === 'other') {
            this.certificateViewErrorFlag = true;
            this.certificateViewError = 'Unable to get the certificate!';
          }
        });
  }

  changeStatus(status) {
    this.paperflowService.changeStatus(status, this.certObject)
      .subscribe(
        (res) => {
          if (res.status === 'success') {
            alert('Status updated for Certificate ID ' + this.certObject.certificateID);
            // this.router.navigate(['/pfl']);
            this.getAbsenceById(this.certObject.certificateID);
          } else {
            if (res.status === 'fail') {
              alert('Error while updating the status!');
            }
          }
        },
        (err) => {
          if (err.status === 401) {
            alert('You are either unauthorized or your seesion is expired!');
            this.sickLeaveListService.redirectToSAB();
          }
          alert('Error while updating the status!');
        });
  }

  getLeaveHistory(employeeID) {
    this.suggetionListFlag = false
    this.empID = employeeID;
    this.suggestionList = [];
    this.paperflowService.changeLeaveHistory(employeeID)
      .subscribe(
        (res) => {
          if (res.status === 'success') {
            this.suggetionListFlag = true
            console.log("SUCCESS_IF1")
            console.log(res.response.absenceInfo.length)
            if(res.response.absenceInfo.length > 0){
              console.log("SUCCESS_IF2")
              this.suggestionList = res.response.absenceInfo;
              this.prefdLang = res.response.prefdLang;
              // this.empID = res.response.employeeID;
              this.suggestionList.forEach(element => {
                element['selected'] = this.isInArray(element.absenceID);
                if (this.isMatched(element)) {
                  element['selected'] = false;
                }
              });
            }else{
              this.suggestionList = [];
            }
            
          } else {
            this.suggestionList = [];
          }
        },
        (err) => {
          if (err.status === 401) {
            alert('You are either unauthorized or your seesion is expired!');
            this.sickLeaveListService.redirectToSAB();
          }
          this.suggetionListFlag = true;
          this.suggestionList = [];
          alert('Unable to get the suggestion list!');
        });
  }

  isFailed(item) {
    for (let i = 0; i < this.absenceObjectList.length; i++) {
      if (this.absenceObjectList[i].absenceID === item.absenceID && this.absenceObjectList[i].status === 'Failed') {
        return true;
      }
    }
    return false;
  }

  isMatched(item) {
    for (let i = 0; i < this.absenceObjectList.length; i++) {
      if (this.absenceObjectList[i].absenceID === item.absenceID && this.absenceObjectList[i].status === 'Match') {
        return true;
      }
    }
    return false;
  }

  isInArray(absenceID) {
    return this.absenceIdsList.indexOf(absenceID) !== -1 ? true : false;
  }

  submitLeave(status) {
    let zeroflag = false;
    this.suggestionList.forEach(element => {
      if (element.selected === true) {
        zeroflag = true;
        let submitLeaveObject = new SubmitLeave();
        submitLeaveObject.status = status;
        submitLeaveObject.appLang = this.prefdLang;
        submitLeaveObject.employeeID = this.empID;
        submitLeaveObject.prefdLang = this.prefdLang;
        submitLeaveObject.recordCreatedBy = sessionStorage.getItem('user');
        submitLeaveObject.revisionKey = this.absenceObjectList[0].revisionKey;
        submitLeaveObject.absenceInfo.absenceID = element.absenceID;
        submitLeaveObject.absenceInfo.txnID = element.txnID;
        submitLeaveObject.absenceInfo.absenceUpdatedFlg = 'N';
        submitLeaveObject.absenceInfo.typeOfLeave = element.typeOfLeave;
        submitLeaveObject.absenceInfo.leavePin = element.leavePin;
        submitLeaveObject.absenceInfo.fromDate = element.fromDate;
        submitLeaveObject.absenceInfo.toDate = element.toDate;
        submitLeaveObject.absenceInfo.addressDuringSickness.addressType = element.addressDuringSickness.addressType;
        submitLeaveObject.absenceInfo.addressDuringSickness.addressUpdatedFlg = 'N';
        submitLeaveObject.absenceInfo.addressDuringSickness.address = element.addressDuringSickness.address;
        submitLeaveObject.certificateInfo.certificateAddedOn = this.dateFormatter();
        submitLeaveObject.certificateInfo.certificateRefID = this.certObject.certificateID;
        submitLeaveObject.certificateInfo.certificateUpdatedFlg = 'Y';
        submitLeaveObject.certificateInfo.certificateURI = '';
        this.paperflowService.submitLeave(submitLeaveObject)
          .subscribe(
            (res) => {
            },
            (err) => {
              if (err.status === 401) {
                alert('You are either unauthorized or your seesion is expired!');
                this.sickLeaveListService.redirectToSAB();
              }
            });
      }
    });

    if (zeroflag === false) {
      alert('Please select suggested leave to match before submit!');
      return;
    }
    alert('Certificates submitted & Under process!');
    // this.router.navigate(['/pfl']);
    this.getLeaveHistory(this.empID);
    this.getAbsenceById(this.certObject.certificateID);
  }

  dateFormatter() {
    let temp = new Date();
    let day = temp.getDate().toString().length === 1 ? "0".toString() + temp.getDate().toString() : temp.getDate().toString();
    let month = (temp.getMonth() + 1).toString().length === 1 ? "0".toString() + temp.getMonth().toString() : temp.getMonth().toString();
    let year = temp.getFullYear();

    return day.toString() + "/" + month.toString() + "/" + year.toString();
  }

  certificateID;
  selectedObject;

  showCertificate(certId, selectedObject) {
    this.selectedObject = selectedObject;
    this.certificateEnableFlag = true;
    this.getCertificate(certId, 'other');
  }
  state: string = 'default';

    rotate() {
        //this.state = (this.state === 'default' ? 'rotated' : 'default');
        if(this.state === 'default'){
          this.state = 'rotated90'
        }else if(this.state === 'rotated90'){
           this.state = 'rotated180'
        }else if(this.state === 'rotated180'){
           this.state = 'rotated270'
        }else if(this.state === 'rotated270'){
           this.state = 'rotated360'
           this.state = 'default'
        }else{
          this.state = 'default'
        }
        
    }

  rotateStyle: string;
  rotateImage() {
    this.rotateStyle = 'rotate';
    this.rotateDegree += 90;
    if (this.rotateDegree === 360) {
      this.rotateDegree = 0;
    }
    this.rotateDegreeString = this.rotateDegree.toString();
  }
    
}



// WEBPACK FOOTER //
// ./src/app/hrcc-certificate-view/hrcc-certificate-view.component.ts